import React from 'react';

export const OrdersForSomeoneElse = ({ user }) => {
  return (
    <div className='ordersForSomeoneElse tooltip' data-dd-privacy='mask'>
      <h3 className='tooltipHeading'>This order is for {user.name}</h3>
    </div>
  );
};
